import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useRecoilState } from "recoil";
import { Radio } from "../../../../components/forms/Radio";
import { hierarchyTypeState } from "../atoms/atoms";

export const typeOption = [
  {
    value: "Team",
    label: "Team",
  },
  {
    value: "Hierarchy",
    label: "Hierarchy",
  },
];

interface IHierarchyTypeModalProps {
  isOpen?: boolean;
  onClose?: () => void;
}

export const HierarchyTypeModal: React.FC<IHierarchyTypeModalProps> = ({
  isOpen = false,
  onClose = () => {},
  children,
}) => {
  const [hierarchyType, seteHierarchyType] = useRecoilState(hierarchyTypeState);

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-20 inset-0 bg-black bg-opacity-40 py-10"
          onClose={() => {}}
        >
          <div className="min-h-full inset-0 px-10 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div
                className={`w-1/3 inline-block border-primary border-l-6 px-4 pb-3 pt-2 text-left align-middle transition-all 
              transform bg-white shadow-xl brContainer `}
              >
                <div className="space-y-2">
                  <div className="grid grid-cols-3 justify-between">
                    <label className="col-span-2 ">
                      Select a hierarchy type:
                    </label>
                  </div>
                  <Radio
                    options={typeOption}
                    value={hierarchyType}
                    name="hierarchyType"
                    onChange={(e) => {
                      seteHierarchyType(e.target.value);
                    }}
                  />
                </div>
                {children}
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
